import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.min.css';
import Layout from './layouts/Layout';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getRolByIdPublic } from 'redux/rolesSlice';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TagManager from 'react-gtm-module';
import PageView from 'helpers/PageView';

const App = () => {
  const dispatch = useDispatch();
  const rolesUser = useSelector(state => state.roles.rolesById);
  const userLogged = useSelector(state => state.login.currentUser);

  const tagManagerArgs = {
    gtmId: 'GTM-KDBTV8PX'
  };
  TagManager.initialize(tagManagerArgs);

  if (
    userLogged &&
    JSON.stringify(rolesUser) === '{}' &&
    userLogged.typeOfUser !== 'admin' &&
    userLogged.roles &&
    userLogged.roles.length > 0
  ) {
    userLogged.roles?.map(rol => {
      dispatch(getRolByIdPublic(rol?.id));
    });
  }

  return (
    <BrowserRouter basename={process.env.REACT_APP_LOCAL ? '/' : '/admin'}>
      <PageView />
      <Layout />
      <ToastContainer />
    </BrowserRouter>
  );
};

export default App;
